import type { RelatorioProjeto } from "@/mocks/projetos";

interface Props {
  relatorios: RelatorioProjeto[];
}

const statusReportConfig: Record<string, { badge: string; label: string; icon: string }> = {
  disponivel: { badge: "bg-primary-100 text-primary-700", label: "Disponível", icon: "ri-check-line" },
  gerando: { badge: "bg-warning-100 text-warning-700", label: "Gerando", icon: "ri-loader-line" },
  pendente: { badge: "bg-background-100 text-foreground-500", label: "Pendente", icon: "ri-time-line" },
};

const tipoReportIcon: Record<string, string> = {
  tecnico: "ri-file-text-line",
  inventario: "ri-plant-line",
  fotografico: "ri-camera-line",
  risco: "ri-alert-line",
  especie: "ri-leaf-line",
  bairro: "ri-building-line",
  manejo: "ri-scissors-line",
  executivo: "ri-pie-chart-line",
};

export default function ProjectReportsGrid({ relatorios }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
      {relatorios.map((rel) => {
        const st = statusReportConfig[rel.status] || statusReportConfig.pendente;
        const icon = tipoReportIcon[rel.tipo] || "ri-file-chart-line";
        return (
          <div key={rel.id} className="bg-white rounded-card border border-background-200 p-4 hover:border-background-300 transition-colors flex flex-col">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                <i className={`${icon} text-primary-600 text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-900 font-heading leading-snug">{rel.nome}</p>
                <span className={`badge ${st.badge} mt-1 text-[10px]`}>
                  <i className={`${st.icon} text-[10px]`}></i>
                  {st.label}
                </span>
              </div>
            </div>

            <p className="text-xs text-foreground-500 mb-2 line-clamp-2 flex-1">{rel.descricao}</p>

            <p className="text-xs text-foreground-400 mb-3">
              Última geração: <span className="font-medium text-foreground-600">{rel.ultimaGeracao}</span>
            </p>

            <div className="flex items-center gap-2">
              {rel.status === "disponivel" ? (
                <button className="btn-outline text-xs px-3 py-1.5 flex-1 cursor-pointer">
                  <i className="ri-eye-line"></i>
                  Visualizar
                </button>
              ) : rel.status === "gerando" ? (
                <button className="btn-outline text-xs px-3 py-1.5 flex-1 cursor-pointer opacity-60" disabled>
                  <i className="ri-loader-line animate-spin"></i>
                  Gerando...
                </button>
              ) : (
                <button className="btn-primary text-xs px-3 py-1.5 flex-1 cursor-pointer">
                  <i className="ri-play-line"></i>
                  Gerar
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}